import { EcardFooter } from './EcardFooter';
export default EcardFooter;
